<template>
    <div v-if="reviewState == 1" v-cloak>
   <el-collapse v-model="activeNames"  @change="handleChange" >
    <el-collapse-item name="1">
      <template v-slot:title>
        <h2 class="question-title">1.视频转GIF？</h2>
      </template>
      <div class="answer-content">
        首页选择视频，转换为GIF 最大十秒
      </div>
    </el-collapse-item>
    <el-collapse-item name="2">
      <template v-slot:title>
        <h2 class="question-title">2.提取音频</h2>
      </template>
      <div class="answer-content">
       首页选择视频提取到文件app中<br>


      </div>
    </el-collapse-item>
    <el-collapse-item name="3">
      <template v-slot:title>
        <h2 class="question-title">3.支付成功但是包月或次数没到账？</h2>
      </template>
      <div class="answer-content">
        这可能是支付时网络状态不好引起的，在支付时请保持网络畅通。遇到这种情况请联系客服补单，并在以后的支付中保持网络畅通

      </div>
    </el-collapse-item>
    </el-collapse>
  </div>
  <div v-else-if="reviewState == 0" v-cloak>
  <el-collapse v-model="activeNames"  @change="handleChange" >
    <el-collapse-item name="1">
      <template v-slot:title>
        <h2 class="question-title">1. 支持那些平台？</h2>
      </template>
      <div class="answer-content">
        YouTube 视频下载 <br> Instagram 视频+图片下载 <br> X(Twitter) 视频+图片+Gif下载<br> TikTok 视频+图片下载<br>Pinterest 视频+图片下载
        <br>Snapchat 视频+图片下载
        
      </div>
    </el-collapse-item>

    <el-collapse-item name="2">
      <template v-slot:title>
        <h2 class="question-title">2.下载失败?</h2>
      </template>
      <div class="answer-content">
        请检查您是否开启了VPN，并检查您的网络是否畅通稳定。
      </div>
    </el-collapse-item>
    <el-collapse-item name="3">
      <template v-slot:title>
        <h2 class="question-title">3.是否可以切换到后台下载</h2>
      </template>
      <div class="answer-content">
        是的，我们支持后台下载，您可以在下载中使用其他App。<br>
                        （不能关掉我们的App，尽量不要长时间在后台）
      </div>
    </el-collapse-item>
    <el-collapse-item name="4">
      <template v-slot:title>
        <h2 class="question-title">4.下载进度卡住不动</h2>
      </template>
      <div class="answer-content">
        请检查您的vpn网络，<br>可能是您的vpn网络波动问题，需要重启开关一下vpn即可
                  
      </div>
    </el-collapse-item>
    <el-collapse-item name="5">
      <template v-slot:title>
        <h2 class="question-title">5.支付成功但是包月或次数没到账？</h2>
      </template>
      <div class="answer-content">
       这可能是支付时网络状态不好引起的，在支付时请保持网络畅通。遇到这种情况请联系客服补单，并在以后的支付中保持网络畅通
     
      </div>
    </el-collapse-item>
    <el-collapse-item name="6">
      <template v-slot:title>
        <h2 class="question-title">6.有时候会解析失败？</h2>
      </template>
      <div class="answer-content">
        这可能是地域限制或私密链接引起的问题。
      </div>
    </el-collapse-item>
    <el-collapse-item  name="7">
      <template v-slot:title>
        <h2 class="question-title">7.同一个链接可以多次下载吗？</h2>
      </template>
      <div class="answer-content">
        可以。同一个链接20分钟内重复下载不扣次数。
      </div>
    </el-collapse-item>
    <el-collapse-item  name="8">
      <template v-slot:title>
        <h2 class="question-title">8.如何下载？</h2>
      </template>
      <div class="answer-content">
        复制链接到蛛网X 提取页面，粘贴链接即可下载，部分平台可选分辨率，其余直接下载的一律最高分辨率，
        （国内请开启vpn下载）
      </div>
    </el-collapse-item>
  </el-collapse>
</div>
</template>
<script>
import { ElMessage } from 'element-plus';
export default {
  created() {
    document.title = "常见问题"
    if (this.judgeClient() === "Android") {
      this.getAT()
    } else if (this.judgeClient() === "IOS") {
      this.getFromWebView()

      window.addEventListener("IosFound", this.handleMessage);

      window.handleMessage = this.handleMessage;
    } else if (this.judgeClient() === 'PC'){
      this.getFromWebView();

window.addEventListener('IosFound', this.handleMessage);

window.handleMessage = this.handleMessage;
    }

  },
  deactivated() {
    // 在组件销毁时移除事件监听器，以防止内存泄漏
    window.removeEventListener("IosFound", this.handleMessage);
  },
  data() {
    return {
      reviewState: 1,//不在审核：0、正在审核：1

      activeNames: []
    };
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },

    getFromWebView() {
      if (window.webkit && window.webkit.messageHandlers) {


        window.webkit.messageHandlers.IosFound.postMessage("getReviewState");


      } else {
        if (this.judgeClient() === "IOS") {
          this.reviewState = -1
        }else {
          this.reviewState = 0

        }
        

        ElMessage.error("window.webkit is not defined or missing messageHandlers");
      }
    },

    getAT() {
     
  
        // 假设数据加载成功后 reviewState 被设置为 1 或 0
        this.reviewState = window.android.getReviewState("")
     
    },
    handleMessage(event) {
      // 处理从 WebView 接收到的消息
    
        // 假设数据加载成功后 reviewState 被设置为 1 或 0
        // ElMessage.success(event.data.reviewState);
      this.reviewState = event.data.reviewState
     
   

      // 根据你的实际需求进行处理，例如更新组件状态等
    },
    // 检查客户端
    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
      console.log('是否是Android：' + isAndroid); //true,false
      console.log('是否是iOS：' + isIOS);
      if (isAndroid) {
        return 'Android';
      } else if (isIOS) {
        return 'IOS';
      } else {
        return 'PC';
      }
    },
  },

}
</script>
<style scoped>
.question-title {
  font-size: 15px;
  /* 蓝色标题字体大小 */
  color: #436795;
  /* 蓝色标题颜色 */
}
[v-cloak] { display: none; }

.answer-content {
  text-align: left;
  /* 内容左对齐 */
  margin-left: 20px;
  /* 内容左边距 */
}
</style>